<template>
    <div class="tag-items-container">
        <tag-item 
			v-for="tag in tags" 
			:key="tag.name" 
			:tag="tag"
			:read-only="readOnly"
			@onRemoveTag="onRemoveTag" />

		<tag-item v-if="!readOnly && !!tagList" :tag-list="tagListFiltered" :addText="addText" @onAddTag="onAddTag" />	
    </div>
</template>

<script>
	import TagItem from '@/components/tags/TagItem';

	export default {
		components: {
			TagItem
		},
		props: {
			tags: {
				type: Array,
				required: true
			},
			tagList: {
			  type: Array,
              required: false
         	},
			readOnly: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			addText() {
				return this.tags.length > 0 ? "+" : "Add tag";
			},
			tagListFiltered() {
				if (this.readOnly || !this.tagList)
					return;

				return this.tagList.filter(x => !this.tags.some(t => t.name.toLowerCase() === x.name.toLowerCase()));
			}
		},
		methods: {
			onAddTag(newTagName) {
				if (!this.tags.some(t => newTagName.toLowerCase() === t.name.toLowerCase())) {
					this.$emit('onAddTag', newTagName);
				}			
			},
			onRemoveTag(tagId) {
				this.$emit('onRemoveTag', tagId)
			}
		}
	};
</script>

<style scoped>
    .tag-items-container {
        display: inline-block;
        text-align: left;
    }
</style>